import script from "./MenuTree.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuTree.vue?vue&type=script&setup=true&lang=js"

import "./MenuTree.vue?vue&type=style&index=0&id=5ac61b4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ac61b4b"]])

export default __exports__